import React from 'react';
import { View, StyleSheet, Image } from 'react-native';

import { CAPTION_TEXT, ERROR_TEXT } from '../constants/colors';
import { Text } from '../core-ui';

import { internalError } from '../../assets/';
import { normalizeError } from '../helpers/normalizeText';

type Props = {
  errorMessage: string;
};
export default function InternalError(props: Props) {
  let { errorMessage } = props;

  let caption = `A team of highly trained engineers has been dispatched to deal with this situation (if they are in the mood). \nIf you see them, show them this error below.`;
  return (
    <View style={styles.container}>
      <Image source={internalError} style={styles.image} />

      <Text type="header" style={styles.oopsText}>
        Hmm.. This Doesn&apos;t Look Good...
      </Text>
      <Text color={CAPTION_TEXT} style={styles.captionText}>
        {caption}
      </Text>
      <Text style={styles.errorMessage}>{normalizeError(errorMessage)}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  image: {
    width: 280,
    height: 280,
    marginBottom: 40,
  },
  oopsText: {
    fontSize: 26,
    marginBottom: 16,
  },
  captionText: {
    textAlign: 'center',
    marginBottom: 16,
  },
  errorMessage: {
    marginBottom: 28,
    color: ERROR_TEXT,
  },
});
